import requests from '../util';

const { request } = requests;

const fetchMaleModelList = (
  isAuthenticated,
  pageNum,
  pageSize,
  visibility,
  gender,
  currentProduct,
  searchText,
  category
) => {
  const params = {
    pageNum,
    pageSize,
    visibility,
    gender,
    currentProduct,
    //   searchText,
    category,
  };
  if (gender) {
    params.gender = gender;
  }
  let url = '';
  if (isAuthenticated) {
    url = '/api/v1/model/listModels';
  } else {
    url = '/api/v1/model';
  }
  return request({
    url: url,
    method: 'get',
    params,
  });
};

const modelApi = {
  fetchMaleModelList,
};

export default modelApi;
